/**
 * HR Import & Export hub — /hr/import-export.
 *
 * One sidebar entry consolidating the four data-migration surfaces that
 * were previously separate nav items:
 *   • Bulk import          (/hr/import)
 *   • Set entitlements     (/hr/leave-import)
 *   • Import leave history (/hr/leave-history-import)
 *   • Export leave history (/hr/leave-history-export)
 *
 * Each tab mounts the existing page component unchanged; tabs are gated by
 * the same per-surface flags as before, so nothing becomes visible that
 * wasn't already. Gated on `flags.hrImportExportHub`.
 */
import { HrAccessGuard } from '../components/hr/HrAccessGuard'
import { flags } from '../lib/feature-flags'
import { TabbedHub, type HubTab } from './hr-hub/TabbedHub'
import { HrBulkImportPage } from './HrBulkImportPage'
import { HrEmployeeExportPage } from './HrEmployeeExportPage'
import { HrLeaveBalanceImportPage } from './HrLeaveBalanceImportPage'
import { HrLeaveHistoryImportPage } from './HrLeaveHistoryImportPage'
import { HrLeaveHistoryExportPage } from './HrLeaveHistoryExportPage'
import { HrOrgStructureImportPage } from './HrOrgStructureImportPage'

const TABS: HubTab[] = [
  { key: 'bulk', label: 'Import Employees', flag: 'hrBulkImport', render: () => <HrBulkImportPage /> },
  { key: 'employees-out', label: 'Export Employees', flag: 'hrEmployeeExport', render: () => <HrEmployeeExportPage /> },
  { key: 'org-structure', label: 'Import org structure', flag: 'hrOrgStructureImport', render: () => <HrOrgStructureImportPage /> },
  { key: 'balances', label: 'Set entitlements', flag: 'hrLeaveBalanceImport', render: () => <HrLeaveBalanceImportPage /> },
  { key: 'history-in', label: 'Import leave history', flag: 'hrLeaveHistoryImport', render: () => <HrLeaveHistoryImportPage /> },
  { key: 'history-out', label: 'Export leave history', flag: 'hrLeaveHistoryExport', render: () => <HrLeaveHistoryExportPage /> },
]

export function HrImportExportPage(): JSX.Element | null {
  if (!flags.hrImportExportHub) return null
  return (
    <HrAccessGuard>
      <div className="page">
        <TabbedHub
          testIdPrefix="import-export"
          routePath="/hr/import-export"
          heroTitle="Bulk Import and Export Operations"
          tabs={TABS}
        />
      </div>
    </HrAccessGuard>
  )
}
